var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"watch-trailer-group text-white",on:{"click":_vm.click}},[_c('vk-icon',{staticClass:"icon",attrs:{"icon":"play-circle"}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('WATCH_TRAILER')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }